import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./ipsecVendorsGetActions";
import { IpsecVendorsGetRequestAction } from "./types";

function* ipsecVendorsGet(action: IpsecVendorsGetRequestAction) {
  try {
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "networking/ipsec-vendors"
    );
    yield put(actions.requestSuccess(response.data));
    if (action.resolve) {
      yield call(action.resolve, response.data);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));
    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.IPSEC_VENDORS_GET_REQUEST, ipsecVendorsGet);
}

export default saga;
